import type { NewCarFuelType } from '@/apis/server/new-car/v1/types';

export const conditionToText: Record<string, string> = {
  '>': 'More than',
  '<': 'Less than',
  '=': 'Equal to',
};

export const categoryToText: Record<string, string> = {
  ad: 'Authorised Distributor',
  pi: 'Parallel Importer',
  a: 'Cat A COE',
  b: 'Cat B COE',
};

export const transmissionToText: Record<string, string> = {
  A: 'Auto',
  M: 'Manual',
};

export const dealerTypeToText: Record<string, string> = {
  ad: 'Authorised Distributor',
  pi: 'Parallel Importer',
};

export const fuelTypeToText: Record<NewCarFuelType, string> = {
  diesel: 'Diesel',
  'diesel-electric': 'Diesel Electric',
  electric: 'Electric',
  petrol: 'Petrol',
  'petrol-electric': 'Petrol Electric',
};

export const sortByToText: Record<string, string> = {
  asc: 'Ascend',
  desc: 'Descend',
};

export const vehicleTypeToText: Record<string, string> = {
  commercial: 'All Commercial Vehicles',
  passenger: 'All Passenger Cars',
  sedan: 'Mid-Sized Sedan',
  luxury: 'Luxury Sedan',
  hatchback: 'Hatchback',
  mpv: 'MPV',
  suv: 'SUV',
  sports: 'Sports',
  stationwagon: 'Stationwagon',
  hybrid: 'Hybrid Cars',
  electric: 'Electric Cars',
};

export const coeTypeToText: Record<string, string> = {
  a: 'Cat A COE',
  b: 'Cat B COE',
};
